import { Moment } from 'moment-timezone'
import * as React from 'react'

import { palette, Strong, Text, Title } from 'main/ui'
import { formatDateMonthName } from 'main/util/date'
import { Container } from './TourBadge.styles'

interface IProps {
  beginsAt: Moment
}

export default function TourBadge(props: IProps) {
  const { beginsAt } = props
  const [month, date] = formatDateMonthName(beginsAt).split(' ')
  const time = beginsAt.format('h:mma')

  return (
    <Container>
      <Strong css={{ fontSize: '13px', color: palette.rose2, lineHeight: '14px' }}>{month}</Strong>
      <Title kind="section" css={{ lineHeight: '26px;' }}>
        {date}
      </Title>
      <Text css={{ fontSize: '13px', lineHeight: '18px;' }}>{time}</Text>
    </Container>
  )
}
